// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stackedbarchart_featured__fLe36 {
    display: flex;
    flex-direction: row;
    flex: 1 1;
    align-items: center;
    align-content: center;
    justify-content: space-between;
}

.stackedbarchart_featuredItem__tVlSx {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1;
    margin: 0px 20px;
    padding: 20px;
    border-radius: 10px;
    cursor: pointer;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.stackedbarchart_featuredTitle__yCh9B {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
}

.stackedbarchart_featuredTitleYear__t0xcU {
    font-size: 12px;
    margin-left: 45%;
}

.stackedbarchart_featuredTitleHeader__1L0lh {
    font-size: 14px;
}


.stackedbarchart_featuredTextContainer__4eCdO {
    flex: 1 1;
    min-height: 0;
    margin-right: 40px;
    margin: 10px 0px;
    display: flex;
    align-items: center;
    justify-content: center;

}

.stackedbarchart_featuredText__V9ZLL {
    font-size: 50px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--hsrcOrange);
}


.stackedbarchart_featuredIcon__iStr\\+ {
    font-size: 14px;
    margin-left: 5px;
    color: green;
}

.stackedbarchart_featuredIcon__iStr\\+.stackedbarchart_negative__wbD45 {
    color: red;
}

.stackedbarchart_featuredSub__qqq8N {
    font-size: 15px;
    color: gray;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stackedbarchart_recharts-cartesian-axis-tick__XQREM {
    font-size: 10px !important;
    font-weight: 200;
}


.stackedbarchart_recharts-cartesian-axis__K4mK9 {
    font-size: 10px !important;
    font-weight: 100;
}


text {
    font-size: 10px;
    font-weight: 200;
}

.stackedbarchart_label_text__I6r-p {
    font-size: 10px;
    font-weight: 200;
}`, "",{"version":3,"sources":["webpack://./src/components/StackedBarChartWidget/stackedbarchart.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IAEf,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".featured {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex: 1;\r\n    align-items: center;\r\n    align-content: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitle {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 20px;\r\n}\r\n\r\n.featuredTitleYear {\r\n    font-size: 12px;\r\n    margin-left: 45%;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    font-size: 14px;\r\n}\r\n\r\n\r\n.featuredTextContainer {\r\n    flex: 1;\r\n    min-height: 0;\r\n    margin-right: 40px;\r\n    margin: 10px 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.featuredText {\r\n    font-size: 50px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n\r\n.featuredIcon {\r\n    font-size: 14px;\r\n    margin-left: 5px;\r\n    color: green;\r\n}\r\n\r\n.featuredIcon.negative {\r\n    color: red;\r\n}\r\n\r\n.featuredSub {\r\n    font-size: 15px;\r\n    color: gray;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.recharts-cartesian-axis-tick {\r\n    font-size: 10px !important;\r\n    font-weight: 200;\r\n}\r\n\r\n\r\n.recharts-cartesian-axis {\r\n    font-size: 10px !important;\r\n    font-weight: 100;\r\n}\r\n\r\n\r\ntext {\r\n    font-size: 10px;\r\n    font-weight: 200;\r\n}\r\n\r\n.label_text {\r\n    font-size: 10px;\r\n    font-weight: 200;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featured": `stackedbarchart_featured__fLe36`,
	"featuredItem": `stackedbarchart_featuredItem__tVlSx`,
	"featuredTitle": `stackedbarchart_featuredTitle__yCh9B`,
	"featuredTitleYear": `stackedbarchart_featuredTitleYear__t0xcU`,
	"featuredTitleHeader": `stackedbarchart_featuredTitleHeader__1L0lh`,
	"featuredTextContainer": `stackedbarchart_featuredTextContainer__4eCdO`,
	"featuredText": `stackedbarchart_featuredText__V9ZLL`,
	"featuredIcon": `stackedbarchart_featuredIcon__iStr+`,
	"negative": `stackedbarchart_negative__wbD45`,
	"featuredSub": `stackedbarchart_featuredSub__qqq8N`,
	"recharts-cartesian-axis-tick": `stackedbarchart_recharts-cartesian-axis-tick__XQREM`,
	"recharts-cartesian-axis": `stackedbarchart_recharts-cartesian-axis__K4mK9`,
	"label_text": `stackedbarchart_label_text__I6r-p`
};
export default ___CSS_LOADER_EXPORT___;
